import React, { useState, useEffect } from "react";
import { getVersionNumberAsync } from "../../API/AppVersion/AppVersionAPI";

export const PageFooter = () => {
  const [version, setVersion] = useState<string>("");
  useEffect(() => {
    let isMounted = true;
    async function getVersionNumber() {
      await getVersionNumberAsync().then(resolution => {
        if(isMounted) {
          setVersion(resolution.data);
        }
      });
    }
    getVersionNumber();

    return () => {isMounted = false};
  },[]);
  const versionDisplay = `Status Site - ${version}`;

  return (
    <footer className="footer clear footer-fixed" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div style={{ fontSize: '13px', display: 'flex', alignItems: 'center' }}>
        <div>
          <a href="https://www.hcss.com/" style={{ fontSize: '13px' }}>
          © {new Date().getFullYear()} HCSS
          </a>
        </div>
        <div>
          &nbsp;•&nbsp;
          <a href="https://www.hcss.com/privacy-policy/" style={{ fontSize: '13px' }}>
          Privacy Policy
          </a>
        </div>
        <div>
          &nbsp;•&nbsp;
          <a href="https://www.hcss.com/terms-of-service/" style={{ fontSize: '13px' }}>
          Terms of Service
          </a>
        </div>
        <div>
          &nbsp;•&nbsp;
          {versionDisplay}
        </div>
      </div>
    </footer>
);

}